import * as _ from 'lodash';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CacheService } from '../../global/ng2-cache/services/cache.service';

import { SessionService } from '../../services/session2.service';
import { AutomateFilterType, EmailType, Constants } from '../constants';
import { AutomateFilter } from '../models';
import { EmailTypePickerOptions } from '../email-type-picker/email-type-picker.component';
import { LanguagePickerOptions } from '../language-picker/language-picker.component';
import { SourcePickerOptions } from '../source-picker/source-picker.component';

@Component({
  selector: 'email-filter-group',
  templateUrl: './email-filter-group.component.html'
})

export class EmailFilterGroupComponent implements OnInit {

  includeCampaignReplies: boolean = false;

  @Input() filters: AutomateFilter[];
  @Input() jobName: string;
  @Input() options: EmailFilter[];

  @Output() onChange = new Subject<{ jobName: string, filters: AutomateFilter[] }>();

  sourceFilter: AutomateFilter;
  typeFilter: EmailType[];
  languageFilter: any[];
  bodyFilter: AutomateFilter;
  subjectFilter: AutomateFilter;
  headerFilter: AutomateFilter;
  confidenceFilter: string[];
  session: any;

  constructor(private constants: Constants,
    private sessionService: SessionService,
    private cacheService: CacheService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        session => {
          this.session = session;
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  initView() {
    this.sourceFilter = this.getFilter(this.constants.automateFilterTypes.source.name);
    this.bodyFilter = this.getFilter(this.constants.automateFilterTypes.body.name);
    this.subjectFilter = this.getFilter(this.constants.automateFilterTypes.subject.name);
    this.typeFilter = this.getFilter(this.constants.automateFilterTypes.emailType.name);
    this.languageFilter = this.getFilter(this.constants.automateFilterTypes.language.name);
    this.confidenceFilter = this.getFilter(this.constants.automateFilterTypes.confidence.name);
    this.headerFilter = this.getFilter(this.session.f.emailsThroughDrift && this.constants.automateFilterTypes.header.name);
    if (this.headerFilter) {
      this.includeCampaignReplies = this.headerFilter.exclude.length == 0;
    }
  }


  emitChange() {
    this.onChange.next({ jobName: this.jobName, filters: this.filters });
  }

  getFilter(name: string) {
    let filter = null;
    if (this.supportsFilter(name)) {
      filter = this.filters[this.filters.findIndex(t => { return t.type == name })];
      if (!filter) {
        filter = {
          type: name,
          include: [],
          exclude: []
        };
        this.filters.push(filter);
      }
    }
    return filter;
  }

  supportsFilter(name) {
    let idx = _.findIndex(this.options, o => o.type == name);

    return idx > -1;
  }

  getFilterOptions(name) {
    let options = this.options.find(o => o.type == name).options;
    if (name == 'email_type') {
      // hide direct types if the feauture is not turned on
      // ! hack: This shouldn't be here, but the current design requires it.
      // Ideally, the skill definition would be references to the constants so
      // we can mange things directly.

      if (!this.session.f.directmail) {
        // these options can be in a few distinct places.
        options.advanced.splice(options.advanced.findIndex((t) => { return t.id == 'humandirect' }), 1);
        options.standard.splice(options.standard.findIndex((t) => { return t.id == 'humandirect' }), 1);
        options.standard.splice(options.default.include.findIndex((t) => { return t.id == 'humandirect' }), 1);
        options.standard.splice(options.default.exclude.findIndex((t) => { return t.id == 'humandirect' }), 1);
      }
    }
    return options;
  }

  /** this filter is weird in that the UI is a toggle switch (boolean state)
   * and we need to map it to an exclude filter array. When ON replies to
   * campaign emails are included (no filters), but when OFF they are excluded
   */
  toggleCampaignRepliesFilter() {
    this.includeCampaignReplies = !this.includeCampaignReplies;

    if(this.includeCampaignReplies){
      this.headerFilter.exclude = [];
    }
    else {
      this.headerFilter.exclude = [
        {
          "key": "in-reply-to",
          "value": "<driftmsgid-"
        },
        {
          "key": "references",
          "value": "<driftmsgid-"
        }
      ];
    }
    this.emitChange()
  }
}

export interface EmailFilter {
  type: string;
  options: any;
}



// WEBPACK FOOTER //
// ./client/app/global/email-filter-group/email-filter-group.component.ts